import React from "react";
import { Box, Stack, Text } from "braid-design-system";
import type { FieldConfig, RenderField } from "./transactionScreenTypes";

type TransactionHeaderSectionProps = {
    title: string;
    visibleHeaderFields: FieldConfig[];
    renderField: RenderField;
};

const TransactionHeaderSection: React.FC<TransactionHeaderSectionProps> = ({ title, visibleHeaderFields, renderField }) => {
    return (
        <Box className="transaction-form-card">
            <Stack space="medium">
                <Box>
                    <div className="transaction-form-title">
                        <Text weight="strong">{title}</Text>
                    </div>
                    <div className="transaction-form-grid">
                        {visibleHeaderFields.map((field) => renderField(field))}
                    </div>
                </Box>
            </Stack>
        </Box>
    );
};

export default TransactionHeaderSection;
